// extracted by mini-css-extract-plugin
export default {"item":"SearchResult_item__bTNfm","pill":"SearchResult_pill__HAdZG","name":"SearchResult_name__0E2V3"};